import React, { useContext, useState } from 'react';
import {
  Card,
  Checkbox,
  Col,
  InputNumber,
  List,
  notification,
  Row,
  Space,
  Tabs,
  Image,
  Popconfirm,
  Button,
  Typography,
} from 'antd';
import Meta from 'antd/lib/card/Meta';
import {
  AssetCatalogResponse,
  duplicateAssetCatalog,
  getAssetCatalogByID,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from 'services/assetconfig';
import { CATALOG_IMG_URL } from 'utils/config';
import { toCurrency } from 'utils/utils';
import ModalController from 'components/ModalController';
import { FormInstance } from 'antd/lib/form/Form';
import VirtualList from 'rc-virtual-list';
import { PlusOutlined } from '@ant-design/icons';
import { AuthContext } from 'components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import DuplicateButtonAction from 'components/DuplicatButtonAction';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
import ModalControllerNV from 'components/ModalControllerNV';
import AssetCatalogSingleItemDetailModal from 'components/AssetCatalogModal/AssetCatalogSingleItemDetailModal';
import GetLabel from 'DisplayFramework/components/GetLabel';

const { TabPane } = Tabs;

export type CardProps = {
  item: AssetCatalogResponse;
  onSelect: (
    item: AssetCatalogResponse,
    nbasset: number,
    selectedServices: ParAssetCatalogServiceResponse[],
    selectedOption: ParAssetCatalogOptionResponse[]
  ) => void;
  form: FormInstance;
  myCatalog?: boolean;
  refetch?: any;
  hideServiceAndOptions?: boolean;
};

const Cards = (props: CardProps) => {
  const { item, onSelect, myCatalog, refetch, hideServiceAndOptions } = props;

  const { isInspect } = useContext(AuthContext);
  const history = useHistory();

  let listAsset = item;
  // eslint-disable-next-line no-unused-vars
  const [Asset, setAsset] = useState<any[]>([]);
  const [nbasset, setnbasset] = useState(1);

  const handlePreviewCATALOG = (catalogid: number) => {
    getAssetCatalogByID({
      catalogid: catalogid,
    })
      .then((response) => {
        if (response.code === '200') {
          setAsset(response.list);
        } else {
          notification.error({
            message: response.message,
          });
        }
      })
      .catch((response) => {
        notification.error({
          message: response.message,
        });
      });
  };
  const Alert = () => {
    return notification.error({
      message: 'Offer is mandatory',
    });
  };

  const [activeKey, setActiveKey] = useState('1');

  const [selectedServices, setSelectedServices] = useState<
    ParAssetCatalogServiceResponse[]
  >([]);

  let [selectedOption, setselectedOption] = useState<
    ParAssetCatalogOptionResponse[]
  >([]);

  const imageSrc = CATALOG_IMG_URL + item.assetpictureurl;

  const [assetnetamountWithOptions, setAssetnetamountWithOptions] = useState(
    listAsset.assetnetamount
  );
  const [
    assetnetamountorigineWithOptions,
    setAssetnetamountorigineWithOptions,
  ] = useState(listAsset.assetnetamountorigine);
  const [assettaxamountWithOptions, setAssettaxamountWithOptions] = useState(
    listAsset.assettaxamount
  );
  const [assetgrossamountWithOptions, setAssetgrossamountWithOptions] =
    useState(listAsset.assetgrossamount);

  return (
    <Card
      style={{
        alignContent: 'center',
        boxShadow: '0px 0px 7px rgb(0 0 0 / 9%)',
      }}
      // className="AssetCatalogItem"
    >
      <Tabs
        activeKey={activeKey}
        centered
        onChange={(e) => {
          setActiveKey(e);
        }}
        tabBarExtraContent={
          myCatalog && (
            <TasksListPopover
              entityId={item.catalogid}
              entityReference={'ID : ' + item?.catalogid}
              entityName="CATALOG"
              title={item.assetlabel}
              onClose={() => {
                refetch && refetch();
              }}
            >
              <Button
                icon={<IActions height="15px" width="15px" />}
                size="middle"
              ></Button>
            </TasksListPopover>
          )
        }
      >
        <TabPane tab="Asset" key="1" animated>
          <Row justify="center">
            <Card
              className="cardcatalog"
              bordered={false}
              style={{
                borderRadius: '5px',
              }}
              title={
                <strong>
                  <ModalControllerNV
                    content={({ setVisible, visible }) => (
                      <a onClick={() => setVisible(true)}>
                        {listAsset?.assetlabel}
                      </a>
                    )}
                    modal={({ setVisible, visible }) => (
                      <AssetCatalogSingleItemDetailModal
                        currcode={item?.currcode}
                        item={listAsset}
                        visible={visible}
                        onCancel={() => {
                          setVisible(false);
                        }}
                        onSelect={() => {}}
                        preview
                      />
                    )}
                  />
                </strong>
              }
              cover={
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <Image
                        preview={{ visible: false }}
                        src={CATALOG_IMG_URL + listAsset?.assetpictureurl}
                        // style={{ height: '180px', width:'80%' }}
                        style={{
                          width: '100%',
                          padding: '0px 50px',
                          height: '180px',
                        }}
                        onClick={(e) => {
                          setVisible(true);
                          e.stopPropagation();
                          myCatalog
                            ? history.push(
                                `/configuration/asset-catalog/${item.catalogid}/catalog`
                              )
                            : handlePreviewCATALOG(
                                Number(listAsset?.catalogid)
                              );
                        }}
                      />
                      <AssetCatalogSingleItemDetailModal
                        currcode={item?.currcode}
                        item={listAsset}
                        visible={visible}
                        onCancel={() => {
                          setVisible(false);
                        }}
                        onSelect={() => {}}
                        preview
                      />
                    </>
                  )}
                </ModalController>
              }
              actions={[
                !myCatalog && (
                  <InputNumber
                    key={2}
                    size="middle"
                    value={nbasset}
                    min={1}
                    max={100}
                    onChange={(nb) => setnbasset(nb ?? 0)}
                    style={{ width: '70%' }}
                  />
                ),
                <Typography.Link
                  key={1}
                  onClick={() => {
                    onSelect(
                      {
                        ...item,
                        assetnetamountorigine: item.assetnetamount,
                        assetgrossamountorigine: item.assetgrossamount,
                        assetnetamount: assetnetamountWithOptions,
                        assettaxamount: assettaxamountWithOptions,
                        assetgrossamount: assetgrossamountWithOptions,
                        assetmulticomponents:
                          selectedOption.length > 0
                            ? true
                            : item?.assetmulticomponents,
                      },
                      nbasset,
                      selectedServices,
                      selectedOption
                    );
                  }}
                >
                  <Button icon={<PlusOutlined />} type="primary">
                    <GetLabel label="add" />
                  </Button>
                </Typography.Link>,
              ]}
            >
              <Meta
                title={
                  <div>
                    {item?.assetnetamountorigine > item?.assetdiscountamount &&
                    item?.assetdiscountperc !== 0 &&
                    item?.assetdiscountperc != null ? (
                      <>
                        <Row style={{ color: 'red' }} justify="end">
                          {'-' + item.assetdiscountperc + '%'}
                        </Row>
                        <Row justify="center" style={{ color: 'red' }}>
                          <strong
                            style={{
                              fontSize: '25px',
                              textAlign: 'center',
                              color: 'red',
                            }}
                          >
                            {' '}
                            {toCurrency(
                              item.assetnetamountorigine -
                                item?.assetdiscountamount,
                              item?.currcode ??
                                localStorage.getItem('currcode') ??
                                ''
                            )}
                          </strong>
                        </Row>

                        {/* <Row className="strikethrough" justify="end"> */}
                        <Row style={{ color: '#293c72' }}>
                          <GetLabel label="Old Amount" />:
                          {toCurrency(
                            item.assetnetamountorigine,
                            item?.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Row>
                      </>
                    ) : (
                      <>
                        <div>&nbsp;</div>
                        <Row justify="center">
                          <div style={{ color: 'red' }}>
                            <strong
                              style={{
                                marginRight: '2%',
                                fontSize: '20px',
                                textAlign: 'center',
                                color: 'red',
                              }}
                            >
                              {item?.assetnetamount
                                ? toCurrency(
                                    item.assetnetamount,
                                    item?.currcode ??
                                      localStorage.getItem('currcode') ??
                                      ''
                                  )
                                : toCurrency(
                                    item.assetnetamountorigine,
                                    item?.currcode ??
                                      localStorage.getItem('currcode') ??
                                      ''
                                  )}
                            </strong>
                          </div>
                        </Row>
                        <div style={{ height: 30 }}>&nbsp;</div>
                      </>
                    )}
                    {/* {toCurrency(assetnetamountWithOptions,item?.currcode)} */}
                  </div>
                }
                description={
                  myCatalog && (
                    <Space
                      direction="horizontal"
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <Col
                        style={{ marginTop: '3px' }}
                        onKeyPress={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <Popconfirm
                          title="Sure to duplicate?"
                          onConfirm={(e: any) => {
                            e.stopPropagation();
                            !isInspect &&
                              duplicateAssetCatalog({
                                catalogid: item.catalogid,
                                catalogidorigine: 0,
                                isnewVersion: false,
                              }).then((res) => {
                                history.push(
                                  `/configuration/asset-catalog/${res.data.catalogid}/catalog`
                                );
                                notification.success({ message: res.message });
                                //refetch();
                              });
                          }}
                        >
                          <DuplicateButtonAction comcode="duplicate" />
                        </Popconfirm>
                      </Col>
                      <Col style={{ marginTop: '3px' }}>
                        <Popconfirm
                          title="Sure to create a new version ?"
                          onConfirm={() => {
                            !isInspect &&
                              duplicateAssetCatalog({
                                catalogid: item.catalogid,
                                catalogidorigine:
                                  item.catalogidorigine ?? item.catalogid,
                                isnewVersion: true,
                              }).then((res) => {
                                history.push(
                                  `/configuration/asset-catalog/${res.data.catalogid}/catalog`
                                );
                                notification.success({ message: res.message });
                                //refetch();
                              });
                          }}
                        >
                          <DuplicateButtonAction comcode="newVersion" />
                        </Popconfirm>
                      </Col>
                    </Space>
                  )
                }
              />
            </Card>
          </Row>
        </TabPane>
        {!hideServiceAndOptions && (
          <>
            <TabPane tab="Services" key="2">
              <Row justify="center">
                <Card
                  bordered={false}
                  className="cardcatalog"
                  style={{
                    borderRadius: '5px',
                  }}
                  title={
                    <strong style={{ textAlign: 'center' }}>
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <a onClick={() => setVisible(true)}>
                            {listAsset?.assetlabel}
                          </a>
                        )}
                        modal={({ setVisible, visible }) => (
                          <AssetCatalogSingleItemDetailModal
                            currcode={item?.currcode}
                            item={listAsset}
                            visible={visible}
                            onCancel={() => {
                              setVisible(false);
                            }}
                            onSelect={() => {}}
                            preview
                          />
                        )}
                      />
                    </strong>
                  }
                  cover={
                    <ModalController>
                      {({ setVisible, visible }) => (
                        <>
                          <img
                            alt="example"
                            src={CATALOG_IMG_URL + listAsset?.assetpictureurl}
                            style={{
                              height: '180px',
                            }}
                            onClick={(e) => {
                              setVisible(true);
                              e.stopPropagation();
                              myCatalog
                                ? history.push(
                                    `/configuration/asset-catalog/${item.catalogid}/catalog`
                                  )
                                : handlePreviewCATALOG(
                                    Number(listAsset?.catalogid)
                                  );
                            }}
                          />
                          <AssetCatalogSingleItemDetailModal
                            currcode={item?.currcode}
                            item={listAsset}
                            visible={visible}
                            onCancel={() => {
                              setVisible(false);
                            }}
                            onSelect={() => {}}
                            preview
                          />
                        </>
                      )}
                    </ModalController>
                  }
                  actions={[
                    !myCatalog && (
                      <InputNumber
                        key={2}
                        size="middle"
                        value={nbasset}
                        min={1}
                        max={100}
                        onChange={(nb) => setnbasset(nb ?? 0)}
                        style={{ width: '70%' }}
                      />
                    ),
                    <Typography.Link
                      key={1}
                      onClick={() => {
                        onSelect(
                          {
                            ...item,
                            assetnetamountorigine: item.assetnetamount,
                            assetgrossamountorigine: item.assetgrossamount,
                            assetnetamount: assetnetamountWithOptions,
                            assettaxamount: assettaxamountWithOptions,
                            assetgrossamount: assetgrossamountWithOptions,
                            assetmulticomponents:
                              selectedOption.length > 0 ? true : false,
                          },
                          nbasset,
                          selectedServices,
                          selectedOption
                        );
                      }}
                    >
                      <Button icon={<PlusOutlined />} type="primary">
                        <GetLabel label="add" />
                      </Button>
                    </Typography.Link>,
                  ]}
                >
                  {item?.assetCatalogServices?.length > 0 && (
                    <>
                      {/* <List
                          size="small"
                          style={{
                            width: '100%',
                            height: 120,
                          }}
                          dataSource={item?.assetCatalogServices ?? []}
                          renderItem={(e) => (
                            <List.Item style={{ padding: '8px 1px' }}>
                              <Checkbox
                                value={e.servcode}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    setSelectedServices([
                                      ...selectedServices,
                                      e,
                                    ]);
                                  } else {
                                    e.servcode', e.servcode);
                                    let items = selectedServices?.filter(
                                      (i) => i.servcode !== a.target.value
                                    );
                                    setSelectedServices(items);
                                  }
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <Col>
                                    {e.servlabel +
                                      ' : ' +
                                      toCurrency(
                                        e.servfixedamount,
                                        item.currcode
                                      )}
                                  </Col>
                                </div>
                              </Checkbox>
                            </List.Item>
                          )}
                        /> */}

                      <List>
                        <VirtualList
                          data={item?.assetCatalogServices ?? []}
                          height={120}
                          itemKey="id"
                          itemHeight={20}
                        >
                          {(e: any) => (
                            <List.Item style={{ padding: '8px 1px' }}>
                              <Checkbox
                                value={e.servcode}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    setSelectedServices([
                                      ...selectedServices,
                                      e,
                                    ]);
                                  } else {
                                    let items = selectedServices?.filter(
                                      (i) => i.servcode !== a.target.value
                                    );
                                    setSelectedServices(items);
                                  }
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    // justifyContent: 'space-between',
                                  }}
                                >
                                  <Col>
                                    {e.servlabel +
                                      ' : ' +
                                      toCurrency(
                                        e.servfixedamount,
                                        item.currcode
                                      )}
                                  </Col>
                                </div>
                              </Checkbox>
                            </List.Item>
                          )}
                        </VirtualList>
                      </List>
                    </>
                  )}
                  <Meta
                    title={
                      <div>
                        {item?.assetnetamountorigine >
                          item?.assetdiscountamount &&
                        item?.assetdiscountperc !== 0 &&
                        item?.assetdiscountperc != null ? (
                          <>
                            <Row style={{ color: 'red' }} justify="end">
                              {'-' + item.assetdiscountperc + '%'}
                            </Row>
                            <Row justify="center" style={{ color: 'red' }}>
                              <strong
                                style={{
                                  fontSize: '25px',
                                  textAlign: 'center',
                                  color: 'red',
                                }}
                              >
                                {' '}
                                {toCurrency(
                                  item.assetnetamountorigine -
                                    item?.assetdiscountamount,
                                  item?.currcode ??
                                    localStorage.getItem('currcode') ??
                                    ''
                                )}
                              </strong>
                            </Row>

                            {/* <Row className="strikethrough" justify="end"> */}
                            <Row>
                              <GetLabel label="Old Amount" />:
                              {toCurrency(
                                item.assetnetamountorigine,
                                item?.currcode ??
                                  localStorage.getItem('currcode') ??
                                  ''
                              )}
                            </Row>
                          </>
                        ) : (
                          <>
                            <div>&nbsp;</div>
                            <Row justify="center">
                              <div style={{ color: 'red' }}>
                                <strong
                                  style={{
                                    marginRight: '2%',
                                    fontSize: '20px',
                                    textAlign: 'center',
                                    color: 'red',
                                  }}
                                >
                                  {item?.assetnetamount
                                    ? toCurrency(
                                        item.assetnetamount,
                                        item?.currcode ??
                                          localStorage.getItem('currcode') ??
                                          ''
                                      )
                                    : toCurrency(
                                        item.assetnetamountorigine,
                                        item?.currcode ??
                                          localStorage.getItem('currcode') ??
                                          ''
                                      )}
                                </strong>
                              </div>
                            </Row>
                            <div style={{ height: 30 }}>&nbsp;</div>
                          </>
                        )}
                        {/* <div 
                        style={{
                          textAlign:'center',
                          color: 'red',
                          fontSize: '20px',
                          marginTop:'15px',
                          marginBottom:'15px' 
                        }}
                      >
                        {toCurrency(assetnetamountWithOptions,item?.currcode)} */}
                      </div>
                    }
                    description={
                      myCatalog && (
                        <Space
                          direction="horizontal"
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <Col style={{ marginTop: '3px' }}>
                            <Popconfirm
                              title="Sure to duplicate?"
                              onConfirm={() => {
                                !isInspect &&
                                  duplicateAssetCatalog({
                                    catalogid: item.catalogid,
                                    catalogidorigine: 0,
                                    isnewVersion: false,
                                  }).then((res) => {
                                    history.push(
                                      `/configuration/asset-catalog/${res.data.catalogid}`
                                    );
                                    notification.success({
                                      message: res.message,
                                    });
                                    //refetch();
                                  });
                              }}
                            >
                              <DuplicateButtonAction comcode="duplicate" />
                            </Popconfirm>
                          </Col>
                          <Col style={{ marginTop: '3px' }}>
                            <Popconfirm
                              title="Sure to create a new version ?"
                              onConfirm={() => {
                                !isInspect &&
                                  duplicateAssetCatalog({
                                    catalogid: item.catalogid,
                                    catalogidorigine:
                                      item.catalogidorigine ?? item.catalogid,
                                    isnewVersion: true,
                                  }).then((res) => {
                                    history.push(
                                      `/configuration/asset-catalog/${res.data.catalogid}`
                                    );
                                    notification.success({
                                      message: res.message,
                                    });
                                    //refetch();
                                  });
                              }}
                            >
                              <DuplicateButtonAction comcode="newVersion" />
                            </Popconfirm>
                          </Col>
                        </Space>
                      )
                    }
                  />
                </Card>
              </Row>
            </TabPane>

            <TabPane tab="Options" key="3">
              <Row justify="center">
                <Card
                  bordered={false}
                  className="cardcatalog"
                  style={{
                    borderRadius: '5px',
                  }}
                  title={
                    <strong>
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <a onClick={() => setVisible(true)}>
                            {listAsset?.assetlabel}
                          </a>
                        )}
                        modal={({ setVisible, visible }) => (
                          <AssetCatalogSingleItemDetailModal
                            currcode={item?.currcode}
                            item={listAsset}
                            visible={visible}
                            onCancel={() => {
                              setVisible(false);
                            }}
                            onSelect={() => {}}
                            preview
                          />
                        )}
                      />
                    </strong>
                  }
                  cover={
                    <ModalController>
                      {({ setVisible, visible }) => (
                        //  <Carousel
                        //     autoplay
                        //     autoplaySpeed={2000}
                        //     style={{ outline: 'black', color: '#fff' }}
                        //   >
                        <>
                          <Image
                            preview={{ visible: false }}
                            src={CATALOG_IMG_URL + listAsset?.assetpictureurl}
                            style={{ height: '180px' }}
                            onClick={(e) => {
                              setVisible(true);
                              e.stopPropagation();
                              myCatalog
                                ? history.push(
                                    `/configuration/asset-catalog/${item.catalogid}/catalog`
                                  )
                                : handlePreviewCATALOG(
                                    Number(listAsset?.catalogid)
                                  );
                            }}
                          />
                          <AssetCatalogSingleItemDetailModal
                            currcode={item?.currcode}
                            item={listAsset}
                            visible={visible}
                            onCancel={() => {
                              setVisible(false);
                            }}
                            onSelect={() => {}}
                            preview
                          />
                        </>
                        // </Carousel>
                      )}
                    </ModalController>
                  }
                  actions={[
                    !myCatalog && (
                      <InputNumber
                        key={2}
                        size="middle"
                        value={nbasset}
                        min={1}
                        max={100}
                        onChange={(nb) => setnbasset(nb ?? 0)}
                        style={{ width: '70%' }}
                      />
                    ),
                    <Typography.Link
                      key={1}
                      onClick={() => {
                        onSelect(
                          {
                            ...item,
                            // assetnetamountorigine: item.assetnetamount,
                            assetnetamountorigine:
                              assetnetamountorigineWithOptions,
                            assetgrossamountorigine: item.assetgrossamount,
                            assetnetamount: assetnetamountWithOptions,
                            assettaxamount: assettaxamountWithOptions,
                            assetgrossamount: assetgrossamountWithOptions,
                            assetmulticomponents:
                              selectedOption.length > 0 ? true : false,
                          },
                          nbasset,
                          selectedServices,
                          selectedOption
                        );
                      }}
                    >
                      <Button icon={<PlusOutlined />} type="primary">
                        <GetLabel label="add" />
                      </Button>
                    </Typography.Link>,
                  ]}
                >
                  {item?.assetCatalogOptions?.length > 0 && (
                    <>
                      {/* <List
                          size="small"
                          style={{
                            width: '100%',
                            height: 120,
                          }}
                          dataSource={item?.assetCatalogOptions ?? []}
                          renderItem={(e) => (
                            <List.Item>
                              <Checkbox
                                value={e.optvalue}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    setselectedOption([...selectedOption, e]);
                                    setAssetnetamountWithOptions(
                                      assetnetamountWithOptions + e.optnetamount
                                    );
                                    setAssettaxamountWithOptions(
                                      assettaxamountWithOptions + e.opttaxamount
                                    );
                                    setAssetgrossamountWithOptions(
                                      assetgrossamountWithOptions +
                                        e.optgrossamount
                                    );
                                  } else {
                                    let items = selectedOption.filter(
                                      (i) => i.optvalue != a.target.value
                                    );
                                    setAssetnetamountWithOptions(
                                      assetnetamountWithOptions - e.optnetamount
                                    );
                                    setAssettaxamountWithOptions(
                                      assettaxamountWithOptions - e.opttaxamount
                                    );
                                    setAssetgrossamountWithOptions(
                                      assetgrossamountWithOptions -
                                        e.optgrossamount
                                    );

                                    setselectedOption(items);
                                  }
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <Col>
                                    {e.optcodelabel +
                                      ' : ' +
                                      e.optvalue +
                                      ' : ' +
                                      toCurrency(e.optnetamount, item.currcode)}
                                  </Col>
                                </div>
                              </Checkbox>
                            </List.Item>
                          )}
                        /> */}

                      <List>
                        <VirtualList
                          data={item?.assetCatalogOptions ?? []}
                          height={120}
                          itemKey="id"
                          itemHeight={20}
                        >
                          {(e: any) => (
                            <List.Item>
                              <Checkbox
                                value={e.optvalue}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    setselectedOption([...selectedOption, e]);
                                    setAssetnetamountWithOptions(
                                      assetnetamountWithOptions + e.optnetamount
                                    );
                                    setAssettaxamountWithOptions(
                                      assettaxamountWithOptions + e.opttaxamount
                                    );
                                    setAssetnetamountorigineWithOptions(
                                      assetnetamountorigineWithOptions +
                                        e.optnetamount
                                    );
                                    setAssetgrossamountWithOptions(
                                      assetgrossamountWithOptions +
                                        e.optgrossamount
                                    );
                                  } else {
                                    let items = selectedOption.filter(
                                      (i) => i.optvalue !== a.target.value
                                    );
                                    setAssetnetamountWithOptions(
                                      assetnetamountWithOptions - e.optnetamount
                                    );
                                    setAssettaxamountWithOptions(
                                      assettaxamountWithOptions - e.opttaxamount
                                    );
                                    setAssetnetamountorigineWithOptions(
                                      assetnetamountorigineWithOptions -
                                        e.optnetamount
                                    );
                                    setAssetgrossamountWithOptions(
                                      assetgrossamountWithOptions -
                                        e.optgrossamount
                                    );

                                    setselectedOption(items);
                                  }
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <Col>
                                    {e.optcodelabel +
                                      ' : ' +
                                      e.optvaluelabel +
                                      ' : ' +
                                      toCurrency(e.optnetamount, item.currcode)}
                                  </Col>
                                </div>
                              </Checkbox>
                            </List.Item>
                          )}
                        </VirtualList>
                      </List>
                    </>
                  )}
                  <Meta
                    title={
                      <div>
                        {item?.assetnetamountorigine >
                          item?.assetdiscountamount &&
                        item?.assetdiscountperc !== 0 &&
                        item?.assetdiscountperc != null ? (
                          <>
                            <Row style={{ color: 'red' }} justify="end">
                              {'-' + item.assetdiscountperc + '%'}
                            </Row>
                            <Row justify="center" style={{ color: 'red' }}>
                              <strong
                                style={{
                                  fontSize: '25px',
                                  textAlign: 'center',
                                  color: 'red',
                                }}
                              >
                                {' '}
                                {toCurrency(
                                  assetnetamountorigineWithOptions -
                                    item?.assetdiscountamount,
                                  item?.currcode ??
                                    localStorage.getItem('currcode') ??
                                    ''
                                )}
                              </strong>
                            </Row>

                            {/* <Row className="strikethrough" justify="end"> */}
                            <Row>
                              <GetLabel label="Old Amount" />:
                              {toCurrency(
                                item.assetnetamountorigine,
                                item?.currcode ??
                                  localStorage.getItem('currcode') ??
                                  ''
                              )}
                            </Row>
                          </>
                        ) : (
                          <>
                            <div>&nbsp;</div>
                            <Row justify="center">
                              <div style={{ color: 'red' }}>
                                <strong
                                  style={{
                                    marginRight: '2%',
                                    fontSize: '20px',
                                    textAlign: 'center',
                                    color: 'red',
                                  }}
                                >
                                  {item?.assetnetamount
                                    ? toCurrency(
                                        assetnetamountWithOptions,
                                        item?.currcode
                                      )
                                    : // toCurrency(item.assetnetamount, item?.currcode ?? localStorage.getItem('currcode') ?? '')
                                      toCurrency(
                                        item.assetnetamountorigine,
                                        item?.currcode ??
                                          localStorage.getItem('currcode') ??
                                          ''
                                      )}
                                </strong>
                              </div>
                            </Row>
                            <div style={{ height: 30 }}>&nbsp;</div>
                          </>
                        )}
                        {/* <div 
                    style={{
                      textAlign:'center',
                      color: 'red',
                      fontSize: '20px',
                      marginTop:'15px',
                      marginBottom:'15px' 
                    }}
                  >
                    {toCurrency(assetnetamountWithOptions,item?.currcode)} */}
                      </div>
                    }
                    description={
                      myCatalog && (
                        <Space
                          direction="horizontal"
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <Col style={{ marginTop: '3px' }}>
                            <Popconfirm
                              title="Sure to duplicate?"
                              onConfirm={() => {
                                !isInspect &&
                                  duplicateAssetCatalog({
                                    catalogid: item.catalogid,
                                    catalogidorigine: 0,
                                    isnewVersion: false,
                                  }).then((res) => {
                                    history.push(
                                      `/configuration/asset-catalog/${res.data.catalogid}`
                                    );
                                    notification.success({
                                      message: res.message,
                                    });
                                    //refetch();
                                  });
                              }}
                            >
                              <DuplicateButtonAction comcode="duplicate" />
                            </Popconfirm>
                          </Col>
                          <Col style={{ marginTop: '3px' }}>
                            <Popconfirm
                              title="Sure to create a new version ?"
                              onConfirm={() => {
                                !isInspect &&
                                  duplicateAssetCatalog({
                                    catalogid: item.catalogid,
                                    catalogidorigine:
                                      item.catalogidorigine ?? item.catalogid,
                                    isnewVersion: true,
                                  }).then((res) => {
                                    history.push(
                                      `/configuration/asset-catalog/${res.data.catalogid}`
                                    );
                                    notification.success({
                                      message: res.message,
                                    });
                                    //refetch();
                                  });
                              }}
                            >
                              <DuplicateButtonAction comcode="newVersion" />
                            </Popconfirm>
                          </Col>
                        </Space>
                      )
                    }
                  />
                </Card>
              </Row>
            </TabPane>
          </>
        )}
      </Tabs>
    </Card>
  );
};
export default Cards;
